import { activateInlineScripts } from '@otto-ec/global-resources/dom';
import { addEventMergeIdIfVariationChangedAndExists, getGlobalEventMergeIdIfVariationChanged } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';
import { renderPdpRecommendations } from '@otto-ec/nexus-registry/reco/cinemas';

export class RecoProductlineComponent extends BaseComponent {
    public rootSelector = '.js_pdp_reco-productline';
    private isInitialPageLoad = true;
    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }
        const rootElement = this.getRootElement();
        /*                                                                                                              */
        if (rootElement.dataset.useNexusRecoCinemas === 'true') {
            if (!this.isInitialPageLoad) {
                await activateInlineScripts(rootElement);
            }
            const eventMergeId = getGlobalEventMergeIdIfVariationChanged();
            renderPdpRecommendations({
                variationId,
                eventMergeId,
                target: 'productline',
            });
        } else {
            /*                                    */
            window.o_reco?.api.loadRecommendationsForDetailView(
                addEventMergeIdIfVariationChangedAndExists({
                    variationId,
                    prioTarget: this.rootSelector,
                })
            );
        }
        this.isInitialPageLoad = false;
    }
}
